// extracted by mini-css-extract-plugin
export default {"button":"HAk4aE","animatedIcon":"ak0Jgh","content":"QYIbBw"};